/** True when Redux list payload can be reused for this auction (skip API). */
export function canReuseAuctionList(pageData, aid) {
  if (!pageData || pageData === 0 || !pageData.responsedata) return false;
  const cachedAid = pageData.responsedata.aid;
  // Missing aid = unknown auction — never reuse (avoids showing previous auction data)
  if (cachedAid == null || cachedAid === "") return false;
  return String(cachedAid) === String(aid);
}

/** Ensure responsedata carries the current auction aid. */
export function withAuctionAid(responsedata, aid) {
  if (!responsedata || typeof responsedata !== "object") return responsedata;
  return { ...responsedata, aid };
}

/** List to merge when adding an item; empty if Redux cache is for another auction. */
export function getReusableList(pageData, aid) {
  if (!canReuseAuctionList(pageData, aid)) return [];
  return pageData.responsedata.list || [];
}
